import React, { useEffect, useRef } from 'react';

export default function MapFabMobile({ open, setOpen, onFit, onToggleCBC, onOpenGoals, onOpenSettings, onOpenHelp }) {
  const menuRef = useRef(null);

  useEffect(() => {
    function onDocClick(e){
      if (!open) return;
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [open, setOpen]);

  return (
    <div ref={menuRef} className="map-hud" style={{ position: 'absolute', right: 'max(12px, env(safe-area-inset-right))', bottom: 'max(12px, env(safe-area-inset-bottom))', zIndex: 30 }}>
      <button
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
        style={{ width: 56, height: 56, borderRadius: '50%', border: 'none', background: 'var(--primary)', color: '#fff', boxShadow: '0 4px 10px rgba(0,0,0,.2)' }}
      >
        ☰
      </button>
      {open && (
        <ul role="menu" aria-label="Acciones del mapa" style={{ listStyle: 'none', margin: 8, padding: 8, background: 'var(--surface)', border: '1px solid var(--grid)', borderRadius: 12, display: 'grid', gap: 6 }}>
          <li role="menuitem"><button onClick={onFit} style={{ width: '100%' }}>⤢ Encadrar</button></li>
          <li role="menuitem"><button onClick={onToggleCBC} style={{ width: '100%' }}>✅/🚫 CBC</button></li>
          <li role="menuitem"><button onClick={onOpenGoals} style={{ width: '100%' }}>🎯 Objetivos</button></li>
          <li role="menuitem"><button onClick={onOpenSettings} style={{ width: '100%' }}>⚙ Ajustes</button></li>
          <li role="menuitem"><button onClick={onOpenHelp} style={{ width: '100%' }}>❓ Ayuda</button></li>
        </ul>
      )}
    </div>
  );
}


